import { ICongressSession } from './ICongressSession.js'

export interface ICongress {
  endYear: string
  name: string
  number: number
  sessions: ICongressSession[]
  startYear: string
  updateDate: string
  url: string
}
